import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import RoutePlannerSidebar from './routePlannerSidebar';
import RoutePlannerPlans from './plans/routePlannerPlans';
import RoutePlannerDrivers from './drivers/routePlannerDrivers';
import RoutePlanView from './view/routePlannerView';
import RoutePlannerViewSidebar from './routePlannerViewSidebar';

const RoutePlanner = ({ match }) => {
  const [activeDelivery, setActiveDelivery] = useState(null);
  const [activeRouteWithColor, setActiveRouteWithColor] = useState(null);

  const zoomCameraAndSetActiveDelivery = (delivery) => {
    if (delivery && delivery.id !== activeDelivery?.id) {
      setActiveDelivery(delivery);
      setActiveRouteWithColor(null);
    } else {
      setActiveDelivery(null);
    }
  };

  const onRouteWithColorClick = (routeWithColor) => {
    if (routeWithColor && routeWithColor.route.id !== activeRouteWithColor?.route?.id) {
      setActiveRouteWithColor(routeWithColor);
      setActiveDelivery(null);
    } else {
      setActiveRouteWithColor(null);
    }
  };

  return (
    <>
      <Switch>
        <Route
          path={`${match.path}/view/:routePlanId`}
          render={(props) => (
            <RoutePlannerViewSidebar
              {...props}
              setActiveDelivery={zoomCameraAndSetActiveDelivery}
              activeDelivery={activeDelivery}
              activeRouteWithColor={activeRouteWithColor}
              setActiveRouteWithColor={onRouteWithColorClick}
            />
          )}
        />
        <Route>
          <RoutePlannerSidebar />
        </Route>
      </Switch>

      <div className="route-planner">
        <Route exact path={`${match.path}/drivers`} render={(props) => <RoutePlannerDrivers {...props} />} />
        <Route exact path={`${match.path}`} render={(props) => <RoutePlannerPlans {...props} />} />
        <Route exact path={`${match.path}/date/:date`} render={(props) => <RoutePlannerPlans {...props} />} />
        <Route
          exact
          path={`${match.path}/view/:routePlanId`}
          render={(props) => (
            <RoutePlanView
              {...props}
              setActiveDelivery={zoomCameraAndSetActiveDelivery}
              activeDelivery={activeDelivery}
              activeRouteWithColor={activeRouteWithColor}
              setActiveRouteWithColor={onRouteWithColorClick}
            />
          )}
        />
      </div>
    </>
  );
};

RoutePlanner.propTypes = {
  currentUser: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default connect(mapStateToProps)(RoutePlanner);
